// extracted by mini-css-extract-plugin
export default {"text_list":"styles_text_list__EJCFz","text_list_li":"styles_text_list_li__5cHFE"};